export default __webpack_public_path__ + "static/media/grid2.6f9bbe60.png";